import(/* webpackMode: "eager", webpackExports: ["LinkSurveyLoading"] */ "/app/apps/web/modules/survey/link/loading.tsx");
